
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationUnarchiveHeadline: {
    id: "Unarchive.headline",
    defaultMessage: "Are you sure you want to restore your configuration?",
  },
  configurationUnarchiveButton: {
    id: "Unarchive.button",
    defaultMessage: "Accept",
  }, 
});

export default MESSAGES;